import { createApiClient, withAnalyticsHeaders } from "@/lib/api/http";

export const JSON_HEADERS: HeadersInit = {
  "Content-Type": "application/json",
};

export const publicApi = createApiClient();

const apiUrl = process.env.NEXT_PUBLIC_API_ENDPOINT as string;

export async function fetchData<T>(endpoint: RequestInfo, init?: RequestInit) {
  try {
    const response = await fetch(apiUrl + endpoint, {
      ...init,
      headers: withAnalyticsHeaders(init?.headers),
      cache: init?.cache ?? "no-store",
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.detail);
    }

    return data as T;
  } catch (error) {
    throw error;
  }
}

export async function fetchStream(endpoint: RequestInfo, onStream: (chunk: string) => void, init?: RequestInit) {
  try {
    const response = await fetch(apiUrl + endpoint, {
      ...init,
      headers: withAnalyticsHeaders(init?.headers),
      cache: init?.cache ?? "no-store",
    });

    if (!response.ok) {
      throw new Error(`${response.status} (${response.statusText})`);
    }

    const reader = response.body?.getReader();

    if (!reader) {
      throw new Error("No reader!");
    }

    const decoder = new TextDecoder("utf-8");

    while (true) {
      const { value, done } = await reader.read();

      if (done) {
        break;
      }

      const chunk = decoder.decode(value, { stream: true });
      onStream(chunk);
    }
  } catch (error) {
    console.error(error);
  }
}
